import { ConnectionType } from '@yandex-video-platform/goloom-sdk';

import { PeerType } from '../../../../../shared/helpers/transport/cloud-api/types';

export const CONNECTION_TYPE_TO_PEER_TYPE_MAP: { [key in ConnectionType]?: PeerType } = {
    [ConnectionType.CONNECTION_TYPE_PSTN]: PeerType.INCOMING_PHONE_CALL,
};
